const STARFIELD_ID = "article-starfield";

function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

function starCount() {
  if (prefersReducedMotion()) return 0;
  const mobile =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 640px)").matches;
  return mobile ? 60 : 120;
}

function createStar() {
  const star = document.createElement("div");
  star.className = "star";
  const size =
    Math.random() < 0.85
      ? Math.random() * 1.5 + 0.5
      : Math.random() * 3 + 1.5;
  const baseOp = 0.1 + Math.random() * 0.35;
  star.style.cssText = `
    left:${Math.random() * 100}%;
    top:${Math.random() * 100}%;
    width:${size}px;
    height:${size}px;
    --dur:${2 + Math.random() * 4}s;
    --del:${Math.random() * 5}s;
    --base-op:${baseOp};
    opacity:${baseOp};
  `;
  return star;
}

export function initArticleCosmicBackground() {
  const container = document.getElementById(STARFIELD_ID);
  if (!container) return;

  container.replaceChildren();

  const count = starCount();
  const fragment = document.createDocumentFragment();

  for (let i = 0; i < count; i++) {
    fragment.appendChild(createStar());
  }

  container.appendChild(fragment);
}
